import React, { ReactNode, useState } from "react";
import clsx from "clsx";

import { UserI } from "@/lib/types/user";

import { getS3AssetPath } from "shared/lib/helpers";
import { useLiveTime } from "shared/lib/hooks/use-live-time";
import { useTimeout } from "shared/lib/hooks";
import { TIME_INTERVALS } from "shared/lib/constants/time";

interface TitlePropsI {
  user: UserI | undefined;
  title: ReactNode;
}

interface LiveTimePropsI {
  title: ReactNode;
  isVisible: boolean;
}

const Background = () => {
  const [isVisible, setIsVisible] = useState(false);

  useTimeout(() => {
    setIsVisible(true);
  }, TIME_INTERVALS.ONE_HUNDRED_MILLISECONDS * 3);

  return (
    <div
      className={clsx(
        "absolute left-0 top-0 z-0 flex h-[1500px] w-full justify-center",
        "transition-[opacity,transform] duration-500",
        isVisible ? "scale-100 opacity-100" : "scale-50 opacity-0"
      )}
    >
      <img
        src={getS3AssetPath("platform/homepage/gradient-bg.png")}
        loading="lazy"
        className="relative left-[100px] top-[-100px] z-0"
        alt="gradient background"
        onLoad={() => setIsVisible(true)}
      />
    </div>
  );
};

const Title = ({ title, user }: TitlePropsI) => {
  if (title) {
    if (typeof title !== "string") {
      return title;
    }

    return (
      <div>
        <div className="ae-typography-h2">{title}</div>
        <div className="mt-3 h-[1px] w-[80px] bg-[#666666]"></div>
      </div>
    );
  }

  return `Welcome back, ${user?.first_name}!`;
};

const LiveTime = ({ title, isVisible }: LiveTimePropsI) => {
  const liveTime = useLiveTime();

  if (title || !isVisible) {
    return null;
  }

  return (
    <span className="ae-typography-body2 ml-3 text-base-content/60">
      {liveTime}
    </span>
  );
};

export const V3PageHeaderComponents = {
  Background,
  Title,
  LiveTime,
};
